module.exports = __webpack_public_path__ + "img/156.1824e1f7.jpg";